<template>
    <div>
        <vue-dropzone
            id="uploadFileDropzone"
            ref="uploadFileDropzone"
            name="files"
            :options="dropzoneOptions"
            @vdropzone-success="success"
            @vdropzone-complete="complete"
            @vdropzone-file-added="addedfile"
            @vdropzone-error="error"
            style="cursor: pointer;"></vue-dropzone>
        
        <div :id="previewImgID" class="dropzone-preview-img mt-3" ref="previewDiv">
            <table class="table table-striped">
                <tr v-for="(file, index) in files" :data-index="`${file}`" :key="index">
                    <td class="d-flex align-items-center">
                        Name: <input type="text" class="form-control ml-2" v-model="file.content"/>
                    </td>
                    <td><a :href="file.url" target="blank"><u>Download File</u></a></td>
                    <td>
                        <button type="button" class="btn btn-sm btn-outline-danger" @click="removedFile(index)"><i class="icon-remove"></i> Remove</button>
                    </td>
                </tr>
            </table>
            <div class="progress flex-grow-1" v-if="isProcessing">
                <div class="progress-bar" role="progressbar" style="width: 25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
        </div>
        <input type="hidden" :name="hiddenName" v-model="JSON.stringify(files)">
    </div>
</template>
<script>
import vue2Dropzone from 'vue2-dropzone';
export default {
    components: {
        vueDropzone: vue2Dropzone
    },
    props: ['initFiles', 'hiddenName', 'imageableId', 'imageableType', 'token', 'folder'],
    data: function() {
        return {
            dropzoneOptions: {
                url: `/admin/photo?_token=${this.token}&folder=${this.folder}`,
                method: 'post',
                thumbnailWidth: 150,
                maxFilesize: 5,
                acceptedFiles: 'application/pdf',
                paramName: 'image',
                addRemoveLinks: true,
                dictDefaultMessage: '<p class="text-center">Drop files here to upload</p>'
            },
            isProcessing: false,
            files: this.initFiles || [],
            previewImgID: 'previewFile_' + new Date().getTime(),
            resultUrls: []
        };
    },
    methods: {
        addedfile(file) {
            if (file.type != 'application/pdf') {
                this.$dialog.alert('Only upload pdf', {
                    okText: 'OK'
                });
                return;
            } 

            if (file.size > 5242880) {
                this.$dialog.alert('Max 5 MB', {
                    okText: 'OK'
                });
                return;
            } 
            this.isProcessing = true;
        },
        success(file, response) {
            if (response) {
                response['type'] = 10;
                response['content'] = file.name;
                this.files.push(response);
            }
        },
        complete(file) {
            if (file.status == 'error') {
                this.$refs.uploadFileDropzone.removeFile(file);
            }
            this.isProcessing = false;
        },
        removedFile(index) {
            this.$dialog.confirm('Are you sure to delete this file?', {
                okText: 'Yes',
                cancelText: 'No'
            }).then(async () => {
                this.files.splice(index, 1);
                const result = await axios.post('/admin/photo/delete', {
                    public_id: this.files[index].public_id,
                    imageable_type: this.imageableType,
                    imageable_id: this.imageableId
                });
            }).catch(() => {});
        },
        error(file, message, xhr) {
            console.log(file, message, xhr);
            this.isProcessing = false;
        }
    }
};
</script>
